// extracted by mini-css-extract-plugin
export default {"agGridContainer":"deleteSelectionListModal_agGridContainer__3-Bqh","agGridHeader":"deleteSelectionListModal_agGridHeader__P-8CA"};